import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from 'react-i18next';

import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
    Checkbox,
    ClickAwayListener,
    FormControlLabel, FormGroup,
    Grow,
    IconButton,
    InputLabel,
    List,
    ListItem,
    ListItemIcon,
    ListItemSecondaryAction,
    ListItemText,
    Paper,
    Popper,
    Toolbar,
    Chip,
    Menu,
    MenuItem,
    Select,
    Tooltip,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormLabel,
    FormControl,
    Typography
} from '@material-ui/core';
import {
    ViewColumn
} from '@material-ui/icons';
import DragHandleIcon from "@material-ui/icons/DragHandle";
import { Container } from "react-smooth-dnd";
//import { Draggable } from "react-smooth-dnd";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { Draggable } from "react-beautiful-dnd";

const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
    },
    iconButtons: {
        marginRight: theme.spacing(0),
    },
    filterContainer: {
        display: 'flex',
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
        padding: theme.spacing(0),
    },
    checkBox: {
        root: {
            color: theme.palette.primary.contrastText,
            '&$checked': {
                color: theme.palette.primary.contrastText,
            },
        },
    },
}));


const ThemeCheckbox = withStyles((theme) => ({
    root: {
        color: theme.palette.primary.contrastText,
        '&$checked': {
            color: theme.palette.primary.contrastText,
        },
    },
    //checked: {},
}))((props) => <Checkbox color="default" {...props} />);

export default function ColumnSelector({columnOrder, checked, setChecked, setOrder, disableColumns, hideColumnSelector}){
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const [isColumnsOpen, setIsColumnsOpen] = useState(false);
    const [columnsAnchor, setColumnsAnchor] = useState(null);
    const [localChecked, setLocalChecked] = useState(checked);
    const [localOrder, setLocalOrder] = useState(columnOrder);

    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        
        var newOrder = localOrder.slice();
        const [removed] = newOrder.splice(result.source.index, 1);
        newOrder.splice(result.destination.index, 0, removed);
        setLocalOrder(newOrder);
    }
    const handleToggle = (value) => () => {
        let newChecked = Object.assign({}, localChecked);
        if (newChecked[value] === true) {
          newChecked[value] = false;
        } else {
          newChecked[value] = true;
        }
        if (disableColumns.indexOf(value) > -1){
            newChecked[value] = true;
        }
        setLocalChecked(newChecked);
    };
    const handleColumnsOpen = (event) => {
        setColumnsAnchor(event.currentTarget);
        setIsColumnsOpen(true);
        setLocalOrder(columnOrder);
        setLocalChecked(checked);
    };
    const handleColumnsClose = () => {
        setOrder(localOrder);
        setChecked(localChecked);
        setIsColumnsOpen(false);
    };

    const grid = 0;

    const getItemStyle = (isDragging, draggableStyle) => ({
        // some basic styles to make the items look a bit nicer
        //userSelect: "none",
        //padding: grid,
        //margin: `0 0 ${grid*0}px 0`,

        // change background colour if dragging
        //background: isDragging ? "lightgreen" : "grey",

        // styles we need to apply on draggables
        ...draggableStyle,
        left: "auto !important",
        top: "auto !important",
    });

    const getListStyle = isDraggingOver => ({
        //background: isDraggingOver ? "lightblue" : "lightgrey",
        //padding: grid,
        //width: 250
    });

    return (
        <>
        {(hideColumnSelector === undefined || hideColumnSelector === false) && <Tooltip title={t("data")}>
                    <IconButton
                        className={classes.iconButtons}
                        edge='end'
                        aria-haspopup='true'
                        onClick={handleColumnsOpen}
                        color='inherit'>
                        <ViewColumn />
                    </IconButton>
                </Tooltip>}
        <Popper
            open={isColumnsOpen}
            anchorEl={columnsAnchor}
            placement='bottom-end'
            transition
        >
            {({ TransitionProps, placement }) => (
                <Grow
                    {...TransitionProps}
                    style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}>
                    <Paper
                        className={classes.filterContainer}
                        elevation={3}
                        variant='outlined'>
                        <ClickAwayListener onClickAway={handleColumnsClose}>
                            <div>
                                <DragDropContext onDragEnd={onDragEnd}>
                                <Droppable droppableId="droppable">
                                    {(provided, snapshot) => (
                                        <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        style={getListStyle(snapshot.isDraggingOver)}
                                        >
                                        {localOrder.map(({key, label}, index) => {
                                            return(
                                                <Draggable key={key} draggableId={key} index={index}>
                                                {(provided, snapshot) => (
                                                    <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style
                                                    )}
                                                    >
                                                    <ThemeCheckbox
                                                        style={{marginLeft:"5px"}}
                                                        size="small"
                                                        edge="start"
                                                        disabled={disableColumns.indexOf(key) > -1}
                                                        checked={localChecked[key]}
                                                        tabIndex={-1}
                                                        disableRipple
                                                        onClick={handleToggle(key)}
                                                    />
                                                    {t(label)}
                                                    <span className="drag-handle" style={{float:'right', padding:'0 10px', marginTop:"5px"}}><DragHandleIcon/></span>
                                                    </div>
                                                )}
                                                </Draggable>
                                        )})}
                                        {provided.placeholder}
                                        </div>
                                    )}
                                    </Droppable>
                                </DragDropContext>
                            </div>
                        </ClickAwayListener>
                    </Paper>
                </Grow>)}
        </Popper>   
        </>
    );
};